import React from 'react';

import slIMG from './img/icon-lite.svg';
import ssIMG from './img/ss_icon.svg';
import spIMG from './img/sp_icon.svg';
import shIMG from './img/sh_icon.svg';


import ssWPImg from '../../img/Hosting_Plans/wp_ss_icon.svg';
import spWPImg from '../../img/Hosting_Plans/wp_sp_icon.svg';
import shWPImg from '../../img/Hosting_Plans/wp_sh_icon.svg';

import ssDiscImg from './img/price-superstart.svg';
import spDiscImg from './img/price-superpro.svg';
import shDiscImg from './img/price-superhosting.svg';

import ssDiscImgEUR from './img/price-eur-superstart.svg';
import spDiscImgEUR from './img/price-eur-superpro.svg';
import shDiscImgEUR from './img/price-eur-superhosting.svg';

import wpai1Img from '../../img/Hosting_Plans/wpai-1.svg';
import wpai2Img from '../../img/Hosting_Plans/wpai-2.svg';
import wpai3Img from '../../img/Hosting_Plans/wpai-3.svg';

import {__t} from '../common/lang/text-resource';

const initialState = {
	data: {
		'plan_00': {
			icon: slIMG,
			name: __t('СуперЛайт'),
			description: __t('Най-подходящ за малък статичен сайт'),
			// mainFeatures: [
			// 	__t('5 GB пространство'),
			// 	__t('Неограничен трафик'),
			// ],
			mainFeatures: [],
			secondaryFeatures: [
				// __t('2 Backups + Professional Restore'),
				// __t('5 броя пощенски кутии / 5 mailboxes'),
				__t('5 GB NVMe'),
				__t('1 GB RAM'),
				__t('2 Backups'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_01': {
			icon: ssIMG,
			name: __t('СуперСтарт'),
			description: __t('Най-подходящ за сайт с малък брой страници'),
			// mainFeatures: [
			// 	__t('15 GB пространство'),
			// 	__t('Неограничен трафик'),
			// ],
			mainFeatures: [],
			secondaryFeatures: [
				// __t('6 Backups + Professional Restore'),
				// __t('Неограничен брой пощи'),
				__t('15 GB NVMe'),
				__t('1.5 GB RAM'),
				__t('6 Backups'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_02': {
			icon: spIMG,
			name: __t('СуперПро'),
			description: __t('Най-подходящ за фирмен сайт'),
			// mainFeatures: [
			// 	__t('50 GB пространство'),
			// 	__t('Неограничен трафик'),
			// ],
			mainFeatures: [],
			secondaryFeatures: [
				// __t('10 Backups + Professional Restore'),
				// __t('Неограничен брой пощи'),
				__t('50 GB NVMe'),
				__t('2 GB RAM'),
				__t('10 Backups'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_03': {
			icon: shIMG,
			name: __t('СуперХостинг'),
			description: __t('Най-подходящ за старт на онлайн магазин'),
			// mainFeatures: [
			// 	__t('150 GB пространство'),
			// 	__t('Неограничен трафик'),
			// ],
			mainFeatures: [],
			secondaryFeatures: [
				// __t('14 Backups + Professional Restore'),
				// __t('Неограничен брой пощи'),
				// __t('Безплатен GogetSSL'),
				// __t('SuperCache ускорител'),
				__t('150 GB NVMe'),
				__t('3 GB RAM'),
				__t('14 Backups'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		},
		'plan_01_wp': {
			icon: ssWPImg,
			name: __t('СуперСтарт'),
			description: __t('Най-подходящ за личен блог с WordPress'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('15 GB пространство'),
				__t('~ 12 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 1'),
				__t('6 Backups + Professional Restore'),
				__t('Неограничен трафик'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_02_wp': {
			icon: spWPImg,
			name: __t('СуперПро'),
			description: __t('Най-подходящ за фирмен сайт с WordPress'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('50 GB пространство'),
				__t('~ 36 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 3'),
				__t('10 Backups + Professional Restore'),
				__t('Неограничен трафик'),
				__t('Допълнително ускоряване за WordPress'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_03_wp': {
			icon: shWPImg,
			name: __t('СуперХостинг'),
			description: __t('Най-подходящ за WooCommerce магазин'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('150 GB пространство'),
				__t('~ 100 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 6'),
				__t('14 Backups + Professional Restore'),
				__t('Неограничен трафик'),
				__t('Допълнително ускоряване за WordPress'),
				__t('Безплатен GogetSSL'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		},
		'plan_wpai_01': {
			icon: wpai1Img,
			name: __t('AI Start'),
			description: __t('За лични блогове и малки проекти'),
			mainFeatures: [
				__t('15 GB пространство'),
				__t('6 Backups + Professional Restore'),
				__t('Експертна поддръжка Mini Support за WordPress'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('Manager for WordPress by SuperHosting.BG'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_wpai_02': {
			icon: wpai2Img,
			name: __t('AI Advanced'),
			description: __t('За фирмени и презентационни сайтове'),
			mainFeatures: [
				__t('50 GB пространство'),
				__t('10 Backups + Professional Restore'),
				__t('Експертна поддръжка Mini Support за WordPress'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('Manager for WordPress by SuperHosting.BG'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_wpai_03': {
			icon: wpai3Img,
			name: __t('AI Business'),
			description: __t('За сайтове с много данни и голям трафик'),
			mainFeatures: [
				__t('150 GB пространство'),
				__t('14 Backups + Professional Restore'),
				__t('Експертна поддръжка Mini Support за WordPress'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('Manager for WordPress by SuperHosting.BG'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		}
	}
};

const ContextSharedHostingPlanData = React.createContext(initialState);

export default ContextSharedHostingPlanData;